import { render } from "./StyleCreateComp.vue?vue&type=template&id=60cbb8e2&scoped=true&ts=true"
import script from "./StyleCreateComp.vue?vue&type=script&lang=ts"
export * from "./StyleCreateComp.vue?vue&type=script&lang=ts"

import "./StyleCreateComp.vue?vue&type=style&index=0&id=60cbb8e2&scoped=true&lang=css"
import "./StyleCreateComp.vue?vue&type=style&index=1&id=60cbb8e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cbb8e2"]])

export default __exports__